import {Component, effect, inject, signal} from '@angular/core';
import {NgClass} from "@angular/common";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {AssetComponent} from "src/app/presentation/common/asset.component";
import {
  WaterPointButtonComponent
} from "src/app/presentation/main-view/information-center/water-points/water-point-button/water-point-button.component";
import {WaterPointSvgComponent} from "src/app/presentation/common/icons/water-point-svg/water-point-svg.component";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {Device, WaterPoint} from "src/app/infrastructure/moovement-api/models/asset";
import {WaterPointsStore} from 'src/app/domain/assets/water-points/water-points.store';
import {DeviceStore} from 'src/app/domain/devices/device.store';
import {
  UnassignedWaterMonitorButtonComponent
} from "src/app/presentation/main-view/information-center/water-points/unassigned-water-monitor-button/unassigned-water-monitor-button.component";

@Component({
  selector: 'app-water-points',
  imports: [
    WaterPointButtonComponent,
    WaterPointSvgComponent,
    NgClass,
    UnassignedWaterMonitorButtonComponent
],
  templateUrl: './water-points.component.html',
  styleUrl: './water-points.component.css'
})
export class WaterPointsComponent extends AssetComponent {

  filteredWaterPoints = signal<WaterPoint[]>([]);
  filteredUnassignedWaterMonitors = signal<Device[]>([]);

  private filter = signal<string | undefined>(undefined);

  private deviceStore = inject(DeviceStore);
  private waterPointsStore = inject(WaterPointsStore);

  constructor(dataSynchronisationService: DataSynchronisationService, dataSubscriptionService: DataSubscriptionService, viewportService: ViewportService) {
    super(dataSynchronisationService, dataSubscriptionService, viewportService);
    effect(() => {
      this.loading = this.waterPointsStore.loading();
    });

    effect(() => {
      const filter = this.filter();
      if (!filter) {
        this.filteredWaterPoints.set(this.waterPointsStore.entities());
        this.filteredUnassignedWaterMonitors.set(this.deviceStore.unassignedWaterMonitors());
        return;
      }

      const filteredWaterPoints = this.waterPointsStore.entities()
        .filter(waterPoint => {
          return waterPoint?.id?.toLowerCase().includes(filter)
            || waterPoint?.name?.toLowerCase().includes(filter)
        });
      this.filteredWaterPoints.set(filteredWaterPoints);

      const filteredUnassignedWaterMonitors = this.deviceStore.unassignedWaterMonitors()
        .filter(device => {
          return device.id.toLowerCase().includes(filter)
        });
      this.filteredUnassignedWaterMonitors.set(filteredUnassignedWaterMonitors);
    });
  }

  filterResults(input: any) {
    if (!input.value) {
      this.filter.set(undefined);
      return;
    }

    const value = (input.value as string).toLowerCase()
    this.filter.set(value);
  }
}
